import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { RequiredFieldsLabel } from '@grandvisionhq/forms';
import { TitleWithIcon } from '../components/TitleWithIcon/TitleWithIcon.js';
import 'throttle-debounce';
import '@grandvisionhq/carts-v2';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import { ShippingMethods } from './modules/ShippingMethods/layouts/ShippingMethods.js';
import '@grandvisionhq/state';
import '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import './modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import './modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import '../mappers/errors-mapping.js';
import '../state.js';
import './selectors.js';
import { Consents } from '../modules/Consents/layout/Consents.js';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import { CompanyFormContainer } from './containers/CompanyFormContainer.js';
import { ContactDetailsContainer } from './containers/ContactDetailsContainer.js';
import { ImplicitAccountCreationContainer } from './containers/ImplicitAccountCreationContainer.js';
import { ImplicitTermsAndConditionsContainer } from './containers/ImplicitTermsAndConditionsContainer.js';
import { InvoiceFormContainer } from './containers/InvoiceFormContainer.js';
import { ServiceStore } from '../modules/ServiceStore/layout/ServiceStore.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '../selectors.js';
import { ServiceStoreHeading } from '../modules/ServiceStore/layout/ServiceStoreHeading.js';
import '@grandvisionhq/my-account';
import { Footer } from '../modules/Footer/Footer.js';
import '@grandvisionhq/icons';
import 'classnames';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/auth';
import '@grandvisionhq/bloomreach';
import { BillingAndDeliveryForm } from './components/AddressesSection/BillingAndDeliveryForm/BillingAndDeliveryForm.js';
import { AlternateShippingMethodsModal } from './components/AlternativeShippingMethodsList/AlternateShippingMethodsModal.js';
import { CompanySelect } from './components/CompanySelect/CompanySelect.js';

const StepShipping = ({ labels , onNextStep , onPrevStep , isFirstStep , shippingMethodsAsides , shouldShowLoader , handleOptInsLoading , handleServiceStoreLoading , onCloseUpdatedShippingMethodsModal , shouldShowUpdatedShippingMethodsModal =false  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--shipping"
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "orders",
        label: labels.shipmentMethodTitle
    }), /*#__PURE__*/ React.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides
    }), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.generic.title
    }), /*#__PURE__*/ React.createElement(RequiredFieldsLabel, null), /*#__PURE__*/ React.createElement(CompanySelect, null), /*#__PURE__*/ React.createElement(CompanyFormContainer, null), shouldShowLoader ? /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--shipping__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, null), /*#__PURE__*/ React.createElement(ContactDetailsContainer, null), /*#__PURE__*/ React.createElement(InvoiceFormContainer, null), /*#__PURE__*/ React.createElement(ServiceStoreHeading, {
        shouldHideIcon: false,
        title: labels.serviceStoreTitle,
        subtitle: labels.serviceStoreSubtitle
    }), /*#__PURE__*/ React.createElement(ServiceStore, {
        handleServiceStoreLoading: handleServiceStoreLoading
    })), /*#__PURE__*/ React.createElement(Consents, {
        handleOptInsLoading: handleOptInsLoading
    }), /*#__PURE__*/ React.createElement(ImplicitTermsAndConditionsContainer, null), /*#__PURE__*/ React.createElement(Footer, {
        stepName: StepNames.Shipping,
        onPrevStep: onPrevStep,
        onNextStep: onNextStep,
        isFirstStep: isFirstStep
    }), /*#__PURE__*/ React.createElement(ImplicitAccountCreationContainer, null), /*#__PURE__*/ React.createElement(AlternateShippingMethodsModal, {
        onNextStep: ()=>onNextStep(true)
        ,
        closeUpdatedShippingMethodsModal: onCloseUpdatedShippingMethodsModal,
        shouldShowUpdatedShippingMethodsModal: shouldShowUpdatedShippingMethodsModal
    }));
};

export { StepShipping };
//# sourceMappingURL=StepShipping.js.map
